<template>
  <v-container>
    <h1 class="text-center">Rollen-Sync</h1>
    <p class="text-center text-body-2">
      Lege fest, welche Discord-Rolle Zuschauer automatisch anhand ihres Twitch-Status erhalten.
      Ein Feld leer lassen, um diese Zuordnung zu deaktivieren.
    </p>

    <v-alert v-if="loaded && !isCommunityGuild" type="warning" dense outlined class="mb-4 text-left">
      Der gerade in "Meine Server" ausgewählte Server ist <strong>nicht</strong> dein
      Community-Server. Rollen-Sync (Sub/VIP-Rollen für Zuschauer) läuft nur auf deinem
      Community-Server — diese Einstellungen hier werden gespeichert, wirken sich aber nicht
      auf den Live-Sync aus, bis du diesen Server unter "Meine Server" als Community-Server
      festlegst.
    </v-alert>

    <h2>Twitch-Abo-Rollen</h2>
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          :items="roles"
          item-text="name"
          item-value="id"
          label="Sub (jeder aktive Abonnent)"
          v-model="sub"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="roles"
          item-text="name"
          item-value="id"
          label="Sub – Tier 1"
          v-model="sub1"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="roles"
          item-text="name"
          item-value="id"
          label="Sub – Tier 2"
          v-model="sub2"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="roles"
          item-text="name"
          item-value="id"
          label="Sub – Tier 3"
          v-model="sub3"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="roles"
          item-text="name"
          item-value="id"
          label="VIP"
          v-model="vip"
          clearable
        ></v-select>
      </v-col>
    </v-row>

    <h2>Berechtigungsrollen</h2>
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          :items="roles"
          item-text="name"
          item-value="id"
          label="Moderator"
          v-model="mod"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="roles"
          item-text="name"
          item-value="id"
          label="Admin"
          v-model="admin"
          clearable
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.smAndDown"
          :loading="saving"
          @click="saveValues"
        >
          Speichern
        </v-btn>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="settingsSaved"
      timeout="3000"
      color="green"
    >
      Einstellungen gespeichert!
    </v-snackbar>
    <v-snackbar
      v-model="saveFailed"
      timeout="5000"
      color="red"
    >
      Fehler beim Speichern der Einstellungen!
    </v-snackbar>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      settingsSaved: false,
      saveFailed: false,
      saving: false,
      sub: null,
      sub1: null,
      sub2: null,
      sub3: null,
      vip: null,
      mod: null,
      admin: null,
      roles: [],
      loaded: false,
      isCommunityGuild: true,
    };
  },
  mounted() {
    BackendService.loadRoleSyncSettings().then((data) => {
      const roleSync = data.data.roleSync || {};
      this.sub = roleSync.sub || null;
      this.sub1 = roleSync.sub1 || null;
      this.sub2 = roleSync.sub2 || null;
      this.sub3 = roleSync.sub3 || null;
      this.vip = roleSync.vip || null;
      this.mod = roleSync.mod || null;
      this.admin = roleSync.admin || null;
      this.roles = data.data.roles || [];
      this.isCommunityGuild = data.data.isCommunityGuild !== false;
      this.loaded = true;
    });
  },
  methods: {
    saveValues() {
      this.saving = true;
      BackendService.saveRoleSyncSettings({
        sub: this.sub,
        sub1: this.sub1,
        sub2: this.sub2,
        sub3: this.sub3,
        vip: this.vip,
        mod: this.mod,
        admin: this.admin,
      }).then(() => {
        this.settingsSaved = true;
      }).catch(() => {
        this.saveFailed = true;
      }).finally(() => {
        this.saving = false;
      });
    },
  },
};
</script>
